import { useGetSettingQuery } from '../../../api/core'

export const useFreeLiveEventsGamesSetting = () => {
  return useGetSettingQuery('free_live_events_games')
}
